import { EnFlag } from 'icons/EnFlag';
import { FrFlag } from 'icons/FrFlag';
import {
  CarCharacteristicsType,
  Categories,
  ConditionType,
} from 'store/slices/cars/types';
import { AppRoutes } from './types';

export enum LanguageType {
  EN = 'EN',
  FR = 'FR',
}
export const LANGUAGES = [
  {
    code: 'EN',
    Icon: EnFlag,
  },
  { code: 'FR', Icon: FrFlag },
];

export const CAR_CHARACTERISTICS_TITLES = {
  [CarCharacteristicsType.ACCELERATION]: '0 - 100 km/h',
  [CarCharacteristicsType.ENGINE]: 'Engine',
  [CarCharacteristicsType.POWER]: 'Power',
  [CarCharacteristicsType.TRUNK]: 'Trunk',
  [CarCharacteristicsType.TRANSMISSION]: 'Gearbox',
  [CarCharacteristicsType.MAX_SPEED]: 'Max speed',
  [CarCharacteristicsType.SEATS_QUANTITY]: 'N° of seats',
  [CarCharacteristicsType.LIFT_SYSTEM]: 'Car lift system',
};

export const NOT_FOUND_HASH = '#not-found';

export const INVALID_TOKEN_ERROR_MESSAGE = 'Your token is invalid';
export const LOCATIONS_VALIDATION_ERROR_MESSAGE =
  'Please select pickup and drop-off locations';
export const RENTAL_DATES_ERROR_MESSAGE = 'Please select rental dates';

export const RENTAL_DETAILS_GENERAL_VALIDATION_MESSAGE =
  'Please select rental dates as well as pickup and drop-off locations';
export enum Pages {
  HOME = 'HOME',
  SEARCH = 'SEARCH',
  SUBSCRIBE = 'SUBSCRIBE',
  RESERVATION = 'RESERVATION',
  ECOLOGY = 'ECOLOGY',
  ABOUT_US = 'ABOUT_US',
  DASHBOARD = 'DASHBOARD',
  RENTALS = 'RENTALS',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  CARS = 'CARS',
  CUSTOMERS = 'CUSTOMERS',
  DISCOUNTS = 'DISCOUNTS',
  CONTENT = 'CONTENT',
  SETTINGS = 'SETTINGS',
}

export const permissionOrder = ['VIEW', 'CREATE', 'EDIT', 'DELETE'];

export const headerExclusionUrls = [
  AppRoutes.ADMIN,
  AppRoutes.CLIENT_DASHBOARD,
  AppRoutes.CONFIRM_ACCOUNT,
  AppRoutes.RESET_PASSWORD,
];
export const CarContentTranslationKeysByCategory = {
  [Categories.ELEGANT]: 'CAR_CATEGORY_ELEGANT_DESCRIPTION',
  [Categories.SPORT]: 'CAR_CATEGORY_SPORT_DESCRIPTION',
  [Categories.SUPER_SPORT]: 'CAR_CATEGORY_SUPER_SPORT_DESCRIPTION',
  [Categories.EXCLUSIVE]: 'CAR_CATEGORY_EXCLUSIVES_DESCRIPTION',
};

export const CarInfoTitleByCategory = {
  [Categories.ELEGANT]: 'Les Élégantes',
  [Categories.SPORT]: 'Les Sportives',
  [Categories.SUPER_SPORT]: 'Les Super Sportives',
  [Categories.EXCLUSIVE]: 'Les Exclusives',
};

export const CarInfoSubtitleByCategory = {
  [Categories.ELEGANT]: 'Outsiders',
  [Categories.SPORT]: 'Le top des spyders',
  [Categories.SUPER_SPORT]: 'Supercars d’exception',
  [Categories.EXCLUSIVE]: 'Introuvables',
};

export const FILE_MAX_SIZE_IN_MB = 10;

export const ALLOWED_VIDEO_TYPES = [
  'video/mp4',
  'video/webm',
  'video/ogg',
  'video/mpeg',
  'video/quicktime',
];

export const HEIC_IMAGE_TYPE = 'image/heic';
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/webp',
  'image/heic',
];
export const ALLOWED_DOCUMENT_TYPES = ['application/pdf'];
export const FILE_TYPE_VALIDATION_ERROR_MESSAGE =
  'File type is incorrect, please select one of the following formats {formats}';

export enum MediaType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
}
export const ALLOWED_TYPES = {
  [MediaType.VIDEO]: ALLOWED_VIDEO_TYPES,
  [MediaType.IMAGE]: ALLOWED_IMAGE_TYPES,
  [MediaType.FILE]: ALLOWED_DOCUMENT_TYPES,
};
export const FILE_VALIDATION_MESSAGES: Record<MediaType, string> = {
  [MediaType.VIDEO]: `${FILE_TYPE_VALIDATION_ERROR_MESSAGE.replace(
    '{formats}',
    ALLOWED_VIDEO_TYPES.join(','),
  )}`,
  [MediaType.IMAGE]: `${FILE_TYPE_VALIDATION_ERROR_MESSAGE.replace(
    '{formats}',
    ALLOWED_IMAGE_TYPES.join(','),
  )}`,
  [MediaType.FILE]: `${FILE_TYPE_VALIDATION_ERROR_MESSAGE.replace(
    '{formats}',
    ALLOWED_DOCUMENT_TYPES.join(','),
  )}`,
};

export const ECOTREE_URL = 'https://ecotree.green/offres/foret/ajoux';
export const ECOTREE_MAIN_URL = 'https://ecotree.green/';
export const DELIVERY_ERROR_MESSAGE = 'Delivery distance is limited to 150 kms';

export const CONDITION_GENERAL_ERROR_MESSAGE =
  'Your profile is not authorized to rent this car due to';

export const CONDITION_FOR_SECOND_DRIVER_GENERAL_ERROR_MESSAGE =
  'The second driver is not authorized to rent this car due to';

export const CONDITIONS_ERROR_MESSAGES = {
  [ConditionType.DRIVER_MINIMUM_AGE]: 'age restrictions',
  [ConditionType.DRIVER_LICENCE_AGE]: 'licence restrictions',
};

export const CAR_UNAVAILABLE_ERROR_MESSAGE = `The selected car is not available now. It will be available on {date}`;

export const CAR_CATEGORIES_TRANSLATION_KEYS: Record<Categories, string> = {
  [Categories.ELEGANT]: 'CAR_CATEGORY_ELEGANTS',
  [Categories.SPORT]: 'CAR_CATEGORY_SPORTS',
  [Categories.SUPER_SPORT]: 'CAR_CATEGORY_SUPER_SPORTS',
  [Categories.EXCLUSIVE]: 'CAR_CATEGORY_EXCLUSIVES',
};

export const CURRENCY = '€';
export enum BREAKPOINTS {
  MOBILE = 576,
}

export const APP_MEDIA = {
  [Pages.HOME]: {
    HOME_VIDEO: 'v1712962553/Guillaume_Voiture_revue_ohd5ub.mp4',
    ECOLOGY_BANNER: 'v1712962920/ecology-banner_bvrfd8.jpg',
    ABOUT_US_BANNER: 'v1712963077/About-us-new-banner_w0n81o.png',
  },
  [Pages.RESERVATION]: {
    HEADER_BANNER: 'v1712963202/bolides-header-banner_uuzf6a.jpg',
    SECOND_BANNER: 'v1712963381/reservation-second-banner_xkr6xn.jpg',
  },
  [Pages.SEARCH]: {
    HEADER_BANNER: 'v1712963959/search-header-banner_h8jrft.jpg',
  },
  [Pages.ECOLOGY]: {
    HEADER_BANNER: 'v1712964133/ecology-header-banner_oabj8d.jpg',
    MIDDLE_BANNER: 'v1712964300/foret-v2_yfyk1d.jpg',
    ABONNEZ: 'v1712964454/ecology-abonnez_qgvja4.jpg',
    BOTTOM_BANNER: 'v1712964635/FORET_2_midi8s.jpg',
  },
  [Pages.SUBSCRIBE]: {
    HEADER_BANNER: 'v1712964795/ABONNEMENTS_wcyknp.jpg',
    BOTTOM_BANNER: 'subscription-second-banner_copy_gjwcl5.jpg',
  },
  [Pages.ABOUT_US]: {
    HEADER_BANNER: 'v1712963077/About-us-new-banner_w0n81o.png',
  },
};
